// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"e07084cb","287":"42d8d323","290":"c796fe77","344":"21cbe151","362":"2e0873e9","550":"d2b64768","565":"473d6a74","579":"6adb2ad8","608":"808ba580","641":"194b38bc","676":"35da0756","802":"4e64db45","804":"71283efc","805":"3a3e5f87","841":"979eb830"}[chunkId] + ".chunk.js";
};